export default [
  /**
   *  REPORTING
   */
  {
    path: "/kepegawaian/reporting",
    name: "kepegawaian-reporting",
    component: () => import("../../views/rektorat/kepegawaian/Reporting.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Reporting",
          url: "/kepegawaian/reporting",
          active: true,
        },
      ],
      pageTitle: "Reporting",
    },
  },
  /**
   *  PEGAWAI
   */
  {
    path: "/kepegawaian/data-pegawai",
    name: "data-pegawai",
    component: () =>
      import("../../views/rektorat/kepegawaian/DaftarPegawai.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Data Pegawai",
          url: "/kepegawaian/data-pegawai",
          active: true,
        },
      ],
      pageTitle: "Data Pegawai",
    },
  },
  /**
   *  DOSEN
   */
  {
    path: "/kepegawaian/dosen",
    name: "kepegawaian-dosen",
    component: () =>
      import("../../views/rektorat/akademik/dosen/ListDosen.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Dosen",
          url: "/kepegawaian/dosen",
          active: true,
        },
      ],
      pageTitle: "Data Dosen",
    },
  },

  {
    path: "/kepegawaian/sunting-pegawai/:userId",
    name: "kepegawaian-sunting-pegawai",
    component: () => import("../../views/rektorat/kepegawaian/EditPegawai.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Kepegawaian",
          url: "/kepegawaian/data-pegawai",
          active: true,
        },
        {
          title: "Sunting Pegawai",
          active: true,
        },
      ],
      pageTitle: "Sunting Pegawai",
    },
  },

  {
    path: "/kepegawaian/tambah-pegawai",
    name: "kepegawaian-tambah-pegawai",
    component: () =>
      import("../../views/rektorat/kepegawaian/TambahPegawai.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        { title: "Data Pegawai", url: "/kepegawaian/data-pegawai" },

        {
          title: "Tambah Pegawai",
          active: true,
        },
      ],
      pageTitle: "Tambah Pegawai",
    },
  },
  {
    path: "/kepegawaian/detail-pegawai/:userId",
    name: "kepegawaian-detail-pegawai",
    component: () =>
      import("../../views/rektorat/kepegawaian/DetailPegawai.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        { title: "Data Pegawai", url: "/kepegawaian/data-pegawai" },

        {
          title: "Detail Pegawai",
          active: true,
        },
      ],
      pageTitle: "Detail Pegawai",
    },
  },
  /**
   *  ABSENSI
   */

  {
    path: "/kepegawaian/absensi",
    name: "kepegawaian-absensi",
    component: () =>
      import("../../views/rektorat/kepegawaian/absensi/Absensi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Absensi",
          url: "/kepegawaian/absensi",
          active: true,
        },
      ],
      pageTitle: "Absensi",
    },
  },

  {
    path: "/kepegawaian/absensi/rekapitulasi",
    name: "kepegawaian-absensi-rekapitulasi",
    component: () =>
      import(
        "../../views/rektorat/kepegawaian/absensi/RekapitulasiPresensi.vue"
      ),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Absensi",
          url: "/kepegawaian/absensi",
        },
        {
          title: "Rekapitulasi",
          active: true,
        },
      ],
      pageTitle: "Rekapitulasi",
    },
  },

  {
    path: "/kepegawaian/absensi/detail-absensi/:pegawaiId",
    name: "kepegawaian-detail-absensi",
    component: () =>
      import("../../views/rektorat/kepegawaian/absensi/DetailAbsensi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kepegawaian", url: "/submenu/kepegawaian" },
        {
          title: "Absensi",
          url: "/kepegawaian/absensi",
        },
        {
          title: "Rincian Absensi",
          active: true,
        },
      ],
      pageTitle: "Rincian Absensi",
    },
  },
];
